import generator from './generator';
var instructionsActions = {
  getActions: function getActions() {
    var isPrescriber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return generator({
      resource: 'instructions',
      chunkUrlResource: 'instructions-hcd',
      scope: isPrescriber ? 'pat' : 'pat-public'
    });
  }
};
export default instructionsActions;
//# sourceMappingURL=instructions.js.map